import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useMemo, useRef, useState } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import { useIsAdmin } from '../../../hooks/useIsAdmin';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { RequestProductModal } from './RequestProductModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestProductButtonBase = ({
  apiName,
  children,
  trackingData,
  upgradeConfig,
  uiButtonProps,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  onClick,
  isUpgradePoint
}) => {
  const [adminModalOpen, setAdminModalOpen] = useState(false);
  const alertStore = useRef(FloatingAlertStore.newFloatingAlertStore());
  const isAdmin = useIsAdmin('BILLING');

  // wait for the admin check to complete before showing the button
  const buttonReady = isAdmin !== null;
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'REQUEST_PRODUCT'
  }), [apiName, trackingData, upgradeConfig]);
  const internalRef = useRef(null);
  const buttonRef = (uiButtonProps === null || uiButtonProps === void 0 ? void 0 : uiButtonProps.buttonRef) || internalRef;
  useIntersectionObserver({
    targetRef: buttonReady ? buttonRef : undefined,
    onIntersect: () => {
      track('request-product-button', Object.assign({
        action: 'viewed'
      }, trackingProperties));
    }
  });
  const handleButtonClick = () => {
    onClick === null || onClick === void 0 || onClick('REQUEST_PRODUCT');
    setAdminModalOpen(true);
    track('request-product-button', Object.assign({
      action: 'clicked'
    }, trackingProperties));
    if (isUpgradePoint) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, trackingProperties));
    }
  };
  if (!buttonReady) {
    return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, uiButtonProps, {
      loading: true,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.requestProduct"
      })
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      alertStore: alertStore.current
    }), adminModalOpen && /*#__PURE__*/_jsx(RequestProductModal, {
      alertStore: alertStore.current,
      apiName: apiName,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      onClose: () => setAdminModalOpen(false)
    }), /*#__PURE__*/_jsx(Button, Object.assign({}, uiButtonProps, {
      buttonRef: buttonRef,
      "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'request-product-button',
      "data-selenium-id": dataSeleniumId,
      disabled: (uiButtonProps === null || uiButtonProps === void 0 ? void 0 : uiButtonProps.disabled) || !buttonReady,
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      },
      onClick: handleButtonClick,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.requestProduct"
      })
    }))]
  });
};
export const RequestProductButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.REQUEST_PRODUCT_BUTTON,
  children: /*#__PURE__*/_jsx(RequestProductButtonBase, Object.assign({}, props))
});